import { CircularProgress, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import {
//   confirm_one_time_payment,
//   confirm_subscription_payment,
//   requestDetailApi,
// } from "src/DAL/Payment/Payment";
import RequestCard from "./RequestCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStripe } from "@stripe/react-stripe-js";
// import { _change_currency } from "src/DAL/GeneralAPIs/GeneralAPIs";
import { useIds } from "../../hook/AdminContext";
import CardInformation from "./CardInformdation";
import {
  paymentrequest_confirm_onetime_payment,
  paymentrequest_confirm_recurring_payment,
  paymentrequest_onetime_payment,
  paymentrequest_recurring_payment,
} from "../../DAL/PaymentRequest/paymentRequest";
import PaymentSuccessCard from "./PaymentSuccessCard";
const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const PendingRequests = ({ paymentRequest }) => {
  const classes = useStyles();
  const params = useParams();
  //   const { userInfo } = useContentSetting();
  const { userInfo } = useIds();
  const location = useLocation();
  const navigate = useNavigate();
  const stripe = useStripe();
  const [requestData, setRequestData] = useState(paymentRequest);
  const [countriesList, setCountriesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCard, setIsLoadingCard] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [resPostData, setResPostData] = useState("");
  const [showThanks, setShowThanks] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  function test(words) {
    var n = words.split("=");
    return n[n.length - 1];
  }
  let mobileView = test(location.search);

  const payNowForSubscription = async (token, cardElement) => {
    const postData = {
      payment_request_id: requestData._id,
      source_token: token,
    };

    if (clientSecret && resPostData) {
      handleSecureCard(clientSecret, cardElement, resPostData);
      return;
    }
    const result = await paymentrequest_recurring_payment(postData);
    if (result.code === 200) {
      enqueueSnackbar("Payment succeeded successfully.", {
        variant: "success",
      });
      setShowThanks(true);
    } else if (result.code === 210) {
      const formData = {
        payment_request_id: postData.payment_request_id,
        recurring_price_id: result.strip_recurring_price_id,
        subscription_id: result.strip_subscription_id,
      };
      setClientSecret(result.client_secret);
      setResPostData(formData);
      handleSecureCard(result.client_secret, cardElement, formData);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoadingCard(false);
    }

    // const result = await pay_now_for_subscription(postData);
  };

  const getIntentClientSecretForOneTime = async (token, cardElement) => {
    const postData = {
      payment_request_id: requestData._id,
    };

    if (clientSecret && resPostData) {
      handleSecureCard(clientSecret, cardElement, resPostData);
      return;
    }
    const request = await paymentrequest_onetime_payment(postData);
    if (request.code == 200) {
      // if client secret is already generated
      setClientSecret(request.client_secret);
      setResPostData(postData);
      handleSecureCard(request.client_secret, cardElement, postData);
    } else {
      enqueueSnackbar(request.message, { variant: "error" });
      setIsLoadingCard(false);
    }
  };

  const confirmCardPayment = async (postData) => {
    if (requestData.request_type === "recurring") {
      delete postData.payment_intent;
      const result = await paymentrequest_confirm_recurring_payment(postData);
      if (result.code === 200) {
        setIsLoadingCard(false);
        enqueueSnackbar("Payment succeeded successfully.", {
          variant: "success",
        });
        setShowThanks(true);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoadingCard(false);
      }
    } else {
      const result = await paymentrequest_confirm_onetime_payment(postData);
      if (result.code === 200) {
        setIsLoadingCard(false);
        enqueueSnackbar("Payment succeeded successfully.", {
          variant: "success",
        });
        setShowThanks(true);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoadingCard(false);
      }
    }
  };

  const handleSecureCard = (client_secret, cardElement, postData) => {
    enqueueSnackbar("Processing card...", {
      variant: "info",
    });

    stripe
      .confirmCardPayment(client_secret, {
        payment_method: {
          card: cardElement,
        },
      })
      .then(function (result) {
        // Handle result.error or result.paymentIntent
        setIsLoadingCard(false);
        if (result.error) {
          setIsLoadingCard(false);
          enqueueSnackbar(result.error.message, { variant: "error" });
          return;
        }

        confirmCardPayment(postData);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, { variant: "error" });
      });
  };

  const handleCardAction = (card_token, cardElement) => {
    if (requestData.request_type === "recurring") {
      payNowForSubscription(card_token, cardElement);
    } else {
      getIntentClientSecretForOneTime(card_token, cardElement);
    }
  };

  function calculateChargeableAmount(name = "initial_amount") {
    let baseAmount = 0;

    if (requestData.request_type === "onetime") {
      baseAmount = requestData.total_amount;
    } else if (requestData.request_type === "recurring") {
      baseAmount = requestData[name];
    }

    if (baseAmount <= 0) return 0;

    const vatAmount =
      requestData.vat_percentage > 0
        ? (baseAmount * requestData.vat_percentage) / 100
        : 0;

    const chargeableAmount = baseAmount + vatAmount;

    return parseFloat(chargeableAmount.toFixed(2));
  }

  useEffect(() => {
    setShowThanks(false);
  }, []);

  if (showThanks) {
    return (
      <>
        <PaymentSuccessCard
          amount={calculateChargeableAmount()}
          currency={requestData.currency}
          date={new Date()}
          onClose={() => navigate("/payment-requests")}
        />
      </>
    );
  }
  return (
    <div className="container mt-2">
      <div className="d-flex">
        {mobileView == "mobile" ? (
          ""
        ) : (
          <span>
            <IconButton
              className="back-screen-button"
              onClick={() => navigate("/payment-requests")}
            >
              <ArrowBackIcon />
            </IconButton>
          </span>
        )}
        <h2 className="mb-3 ms-2">Payment</h2>
      </div>

      <RequestCard
        bill={requestData}
        showChargeAbleAmount={true}
        isDetailShow={true}
      />
      <div className="row">
        <div className={`col-12`}>
          <CardInformation
            isLoading={isLoadingCard}
            setIsLoading={setIsLoadingCard}
            handleCardAction={handleCardAction}
          />
        </div>
      </div>
    </div>
  );
};

export default PendingRequests;
